import React, { useState } from "react";
import axios from "axios";
import { getSession } from "../utils/session";
import "./DataEntryPopup.css";
import { API_URL } from "../services/api";

function DataEntryPopup({ onClose }) {
  // Estados para comida
  const [name, setName] = useState("");
  const [calories, setCalories] = useState("");
  const [protein, setProtein] = useState("");
  const [carbs, setCarbs] = useState("");
  const [fat, setFat] = useState("");

  // Estados para ejercicio
  const [exerciseName, setExerciseName] = useState("");
  const [caloriesBurned, setCaloriesBurned] = useState("");

  // Estados generales
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");
    try {
      const { token } = await getSession();

      // Guardar comida si se completó el nombre
      if (name || calories) {
        await axios.post(
          `${API_URL}/foods`,
          { name, calories, protein, carbs, fat },
          { headers: { Authorization: `Bearer ${token}` } }
        );
      }

      // Guardar ejercicio si se completó el nombre
      if (exerciseName || caloriesBurned) {
        await axios.post(
          `${API_URL}/exercises`,
          { name: exerciseName, caloriesBurned },
          { headers: { Authorization: `Bearer ${token}` } }
        );
      }

      alert("Datos guardados exitosamente");
      setName("");
      setCalories("");
      setProtein("");
      setCarbs("");
      setFat("");
      setExerciseName("");
      setCaloriesBurned("");
      if (onClose) onClose();
    } catch (err) {
      setError(err?.response?.data?.message || err.message);
    }
    setLoading(false);
  };

  return (
    <div className="popup-overlay">
      <div className="popup data-entry-popup">
        <button className="close-button" onClick={onClose}>
          ✖
        </button>
        <h2>Registrar comida y ejercicio</h2>
        <form onSubmit={handleSubmit}>
          <div className="popup-section">
            <h3>Comida</h3>
            <input
              type="text"
              placeholder="Nombre del alimento"
              value={name}
              onChange={(e) => setName(e.target.value)}
            />
            <input
              type="number"
              placeholder="Calorías"
              value={calories}
              onChange={(e) => setCalories(e.target.value)}
            />
            <input
              type="number"
              placeholder="Proteínas (g)"
              value={protein}
              onChange={(e) => setProtein(e.target.value)}
            />
            <input
              type="number"
              placeholder="Carbohidratos (g)"
              value={carbs}
              onChange={(e) => setCarbs(e.target.value)}
            />
            <input
              type="number"
              placeholder="Grasas (g)"
              value={fat}
              onChange={(e) => setFat(e.target.value)}
            />
          </div>
          <div className="popup-section">
            <h3>Ejercicio</h3>
            <input
              type="text"
              placeholder="Nombre del ejercicio"
              value={exerciseName}
              onChange={(e) => setExerciseName(e.target.value)}
            />
            <input
              type="number"
              placeholder="Calorías quemadas"
              value={caloriesBurned}
              onChange={(e) => setCaloriesBurned(e.target.value)}
            />
          </div>
          {error && (
            <div className="form-error">{error}</div>
          )}
          <button
            type="submit"
            className="save-btn"
            disabled={loading}
            style={{ marginTop: 16 }}
          >
            {loading ? "Guardando..." : "Guardar"}
          </button>
        </form>
      </div>
    </div>
  );
}

export default DataEntryPopup;
